import { render, staticRenderFns } from "./DatasetPreview.vue?vue&type=template&id=04d3a4b8&scoped=true&"
import script from "./DatasetPreview.vue?vue&type=script&lang=js&"
export * from "./DatasetPreview.vue?vue&type=script&lang=js&"
import style0 from "./DatasetPreview.vue?vue&type=style&index=0&id=04d3a4b8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d3a4b8",
  null
  
)

export default component.exports